module.exports = __webpack_public_path__ + "static/media/nonStop.4e389f3c.png";